var TYPE_ARCHIVE = 'archive';
var TYPE_DOCUMENT = 'document';
var isMediaFile = function isMediaFile(mimeType) {
  return [TYPE_ARCHIVE, TYPE_DOCUMENT].includes(mimeType);
};
module.exports = {
  isMediaFile: isMediaFile
};